<mat-card class="portal-page-heading mb-2">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-4">

      <mat-icon class="portal-heading-icon" aria-hidden="true" fontIcon="local_hospital"></mat-icon>
      <h1 class="portal-page-title">{{ assigned? 'Manage My Assignments' : 'Manage Hospital / SICF Licenses'}}</h1>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col mt-6" *ngIf="license.id === 0" [@slideRight]>
  <form [formGroup]="searchForm" *ngIf="!assigned" (ngSubmit)="searchLicenses()">
    <div class="license-search-controls">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput formControlName="searchTerm">
      </mat-form-field>

      <mat-form-field *ngIf="!renewal">
        <mat-label>Statuses</mat-label>
        <mat-select formControlName="statuses" multiple>
          <mat-option *ngFor="let status of sharedService.statuses" [value]="status">{{status}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox formControlName="includeArchived" labelPosition="before">
        <span>Include Archived</span>
      </mat-checkbox>

      <button type="button" mat-raised-button color="primary" (click)="searchLicenses()">Search</button>
    </div>
    <div *ngIf="!renewal" class="license-create-action">
      <button type="button" mat-raised-button color="primary" (click)="createLicense()">Create License</button>
    </div>
  </form>

  <span class="text-xl font-semibold pb-4" *ngIf="assigned">My Assigned Licenses</span>

  <mat-table [dataSource]="licenseSource" matSort #licenseSort="matSort" aria-describedby="hospital licenses" class="mat-elevation-z8 portal-responsive-table">
    <ng-container matColumnDef="licenseId">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">License ID</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">ID</span>
        {{ license.licenseId }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="isSicf">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">SICF</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">SICF</span>
        {{ license.isSicf ? 'Yes' : 'No' }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="hospitalDBAName">
      <mat-header-cell *matHeaderCellDef mat-sort-header=""><abbr title="Doing Business As">DBA</abbr></mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label"><abbr title="Doing Business As">DBA</abbr></span>
        {{ license.hospitalDBAName }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="statuses">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Status</span>
        <div class="flex flex-col">
          <span *ngFor="let status of license.statuses">{{ status.label }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="hospitalPhone">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Phone</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Phone</span>
        {{ license.hospitalPhone | mask:"000-000-0000" }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="hospitalEmail">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Email</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Email</span>
        <span class="break-after-20">{{ license.hospitalEmail }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="assignedToName">
      <mat-header-cell *matHeaderCellDef>Assigned To</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license">
        <span class="mobile-label">Assigned</span>
        <mat-form-field style="margin-top: 0.25em; margin-bottom: -1em; height: 50pt;">
          <mat-select [(value)]="license.assignedToName" (selectionChange)="assignLicense($event, license.id)">
            <mat-option>-- None --</mat-option>
            <mat-option *ngFor="let staff of staff" value={{staff.name}}>{{staff.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span *ngIf="!authService.isAdmin">{{license.assignedTo}}</span>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="licenseColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: licenseColumns" class=""
             [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" #licensePaginator="matPaginator">
  </mat-paginator>
</div>

<div class="flex flex-col w-full pt-4" *ngIf="license.id !== 0" [@slideRight]>
  <div class="grid grid-cols-6 gap-2 items-center pb-4 portal-toolbar">
    <div class="flex flex-row col-span-4 items-center gap-4 portal-actions">
      <span class="text-xl font-semibold">Manage {{ license.entityName }}</span>
      <div class="flex flex-row justify-start items-center portal-actions">
        <span class="text-base" id="licenseId">{{license.licenseId}}</span>
        <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
          matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <button type="button" mat-button color="primary" (click)="viewAuditLog()">Audit Log</button>
    </div>

    <div class="gap-4 flex col-span-2 justify-self-end items-center portal-actions">
      <button *ngIf="editing" type="button" mat-button
              [color]="license.archived? 'primary' : 'warn'"
              (click)="archiveLicense(license, !license.archived)"
              [matTooltip]="license.archived? 'Un-Archive License' : 'Archive License'"
              matTooltipShowDelay="500" matTooltipHideDelay="200">
        {{ license.archived? 'Un-Archive' : 'Archive' }}
      </button>
      <button type="button" mat-raised-button [color]="editing? 'warn' : 'primary'" (click)="toggleEditing(!editing)"
              [matTooltip]="editing? 'Stop Editing' : 'Edit'" matTooltipShowDelay="500" matTooltipHideDelay="200">
        <mat-icon>{{ editing? 'edit_off' : 'edit' }}</mat-icon>
      </button>
      <button class="ml-auto" type="button" mat-raised-button color="primary" (click)="saveLicense()">Save License</button>
      <button *ngIf="!isProduction" type="button" mat-raised-button color="warn" (click)="deleteLicense(license.id)">Delete License</button>
      <button type="button" mat-raised-button color="primary" (click)="closeLicense()">Close</button>
    </div>
  </div>

  <form [formGroup]="licenseForm">
    <!-- Agency Info -->
    <mat-card>
      <mat-card-content>
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col w-full gap-2">
              <div class="flex flex-col gap-2 pb-4">
                <span class="text-lg font-semibold">Demographics</span>

                <!--Review-->
                <div class="flex flex-col md:flex-row gap-2 w-full portal-section-grid hospital-demographics" *ngIf="!editing">
                  <div class="flex flex-col gap-2 w-1/2">
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Is SICF:</span>
                      <span>{{license.isSicf? 'Yes' : 'No'}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Classification:</span>
                      <span>{{license.classification}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Legal Name:</span>
                      <span>{{license.entityName}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3"><abbr title="Doing Business As">DBA</abbr>:</span>
                      <span>{{license.hospitalDBAName}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Phone:</span>
                      <span>{{ license.hospitalPhone | mask:"000-000-0000" }}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Email:</span>
                      <span class="break-after-20">{{license.hospitalEmail}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Fax:</span>
                      <span>{{license.hospitalFax | mask:"000-000-0000"}}</span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2 w-1/2">
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Accredited:</span>
                      <span *ngIf="license.accredited">Yes</span>
                      <span *ngIf="!license.accredited">No</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Accrediting Agency:</span>
                      <span>{{license.accreditingAgency}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Has deemed status?</span>
                      <span *ngIf="license.deemed">Yes</span>
                      <span *ngIf="!license.deemed">No</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Fiscal Year Ending Date:</span>
                      <span>{{license.fiscalYearEnd}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Ownership Category:</span>
                      <span>{{license.ownershipCategory | jsonArrayJoin}}</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row gap-2 w-full portal-section-grid hospital-demographics" *ngIf="!editing">
                  <div class="flex flex-col gap-2 w-1/2">
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Signature:</span>
                      <span>{{license.electronicSignature}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Title:</span>
                      <span>{{license.adminPrintTitle}}</span>
                    </div>
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Signed:</span>
                      <span>{{license.signedDate | date: 'MM/dd/yyyy'}}</span>
                    </div>
                  </div>
                </div>

                <!--Editing-->
                <div class="flex flex-col" *ngIf="editing">
                  <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid">
                    <mat-form-field class="md:w-1/4">
                      <mat-label>License Id</mat-label>
                      <input matInput formControlName="licenseId">
                      <mat-error *ngIf="licenseForm.get('licenseId')?.hasError('required')">
                        You must provide a license ID.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/4">
                      <mat-label>Facility Type</mat-label>
                      <mat-select formControlName="isSicf">
                        <mat-option [value]="false">Hospital</mat-option>
                        <mat-option [value]="true">SICF</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/4" *ngIf="!licenseForm.get('isSicf')?.value && licenseForm.get('isSicf')?.value !== null">
                      <mat-label>Classification</mat-label>
                      <mat-select formControlName="classification">
                        <mat-option value="General Hospital">General Hospital</mat-option>
                        <mat-option value="Psychiatric Hospital">Psychiatric Hospital</mat-option>
                        <mat-option value="Low Occupancy Acute Care Hospital">Low Occupancy Acute Care Hospital</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/4" *ngIf="licenseForm.get('isSicf')?.value && licenseForm.get('isSicf')?.value !== null">
                      <mat-label>Classification</mat-label>
                      <mat-select formControlName="classification">
                        <mat-option value="Drug Alcohol Treatment Center">Drug/Alcohol Treatment Center</mat-option>
                        <mat-option value="Rehabilitation Hospital">Rehabilitation Hospital</mat-option>
                        <mat-option value="Inpatient Hospice">Inpatient Hospice</mat-option>
                        <mat-option value="Religious Institution">Religious Institution</mat-option>
                      </mat-select>
                    </mat-form-field>


                  </div>

                  <div class="hospital-name-fields">
                    <mat-form-field>
                      <mat-label>Legal Name</mat-label>
                      <input matInput formControlName="entityName">
                      <mat-error *ngIf="licenseForm.get('entityName')?.hasError('required')">
                        You must include a name.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>DBA (Doing Business As) Name</mat-label>
                      <input matInput formControlName="hospitalDBAName">
                    </mat-form-field>
                  </div>

                  <div class="hospital-contact-fields">
                    <mat-form-field>
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="hospitalEmail">
                      <mat-error *ngIf="licenseForm.get('hospitalEmail')?.hasError('required')">
                        Email is required
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('hospitalEmail')?.hasError('email')">
                        Not a valid email
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="hospitalPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('hospitalPhone')?.hasError('required')">
                          Phone number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('hospitalPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>

                    <mat-form-field>
                        <mat-label>Fax</mat-label>
                        <input matInput formControlName="hospitalFax" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('hospitalFax')?.invalid">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid">
                    <div class="md:w-1/3">
                      <span class="font-semibold">Does the hospital have deemed status?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="deemed" class="flex flex-row items-start gap-1">
                        <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                        <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                        <mat-error *ngIf="licenseForm.get('deemed')?.touched && licenseForm.get('deemed')?.invalid">
                          You must select an option
                        </mat-error>
                      </mat-radio-group>
                    </div>

                    <div class="flex flex-col md:w-1/3">
                      <span class="font-semibold">Accredited?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="accredited" class="flex flex-row items-start gap-1">
                        <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                        <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                        <mat-error *ngIf="licenseForm.get('accredited')?.touched && licenseForm.get('accredited')?.invalid">
                          You must select an option
                        </mat-error>
                      </mat-radio-group>
                    </div>

                    <mat-form-field class="md:w-1/3">
                      <mat-label>Accrediting Agency</mat-label>
                      <mat-select formControlName="accreditingAgency">
                        <mat-option value="The Joint Commission">The Joint Commission</mat-option>
                        <mat-option value="Det Norske Veritas- Healthcare (DNV)">Det Norske Veritas- Healthcare (DNV)</mat-option>
                        <mat-option value="Center for Improvement in Healthcare Quality (CIHQ)">Center for Improvement in Healthcare Quality (CIHQ)</mat-option>
                        <mat-option value="Accreditation Commission for Health Care (ACHC)">Accreditation Commission for Health Care (ACHC)</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid">
                    <mat-form-field class="md:w-1/3">
                      <mat-label>Fiscal Year Ending Date (MM/DD)</mat-label>
                      <input matInput formControlName="fiscalYearEnd">
                      <mat-error *ngIf="licenseForm.get('fiscalYearEnd')?.hasError('required')">
                        Fiscal Year Date required
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('fiscalYearEnd')?.hasError('pattern')">
                        Format Date as MM/DD
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/3">
                      <mat-label>Ownership Category</mat-label>
                      <mat-select formControlName="ownershipCategory" [multiple]="true">
                        <mat-option value="Church">Church</mat-option>
                        <mat-option value="State">State</mat-option>
                        <mat-option value="Health District">Health District</mat-option>
                        <mat-option value="Partnership">Partnership</mat-option>
                        <mat-option value="City">City</mat-option>
                        <mat-option value="County">County</mat-option>
                        <mat-option value="Individual">Individual</mat-option>
                        <mat-option value="Corporation or LLC">Corporation or LLC</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="md:w-1/3">
                      <!-- empty div to normalize gap spacing-->
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid">
                    <mat-form-field class="md:w-1/3">
                      <mat-label>Signature</mat-label>
                      <input matInput formControlName="electronicSignature">
                      <mat-error *ngIf="licenseForm.get('electronicSignature')?.invalid">
                        A name is required
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/3">
                      <mat-label>Title</mat-label>
                      <input matInput formControlName="adminPrintTitle">
                      <mat-error *ngIf="licenseForm.get('adminPrintTitle')?.invalid">
                        A title is required
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="md:w-1/3">
                      <mat-label>Signed</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="signedDate" matInput [matDatepicker]="signed"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="signed"></mat-datepicker-toggle>
                      <mat-datepicker #signed>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error *ngIf="licenseForm.get('signedDate')?.invalid">
                        Signature date required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <address  [entityId]="license.id"
                        [entityType]="sharedService.hospitalLicense"
                        [limitEntries]="true"
                        [limitTo]="2"
                        [statuses]="license.statuses"
                        [isEditable]="editing">
              </address>

            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>

    <!-- Owners and Documents-->
    <div class="flex flex-col 2xl:flex-row gap-4 py-4 portal-section-grid hospital-owners-documents">
      <!-- Entity Owners -->
      <mat-card class="w-full 2xl:w-1/2">
        <mat-card-content>
          <entity-owner
            [entityId]="license.id"
            [entityType]="sharedService.hospitalLicense"
            [entityGuid]="license.licenseId"
            [statuses]="license.statuses"
            [isSubunit]="false"
            [canChange]="false"
            [isEditable]="editing"
            [showBackgroundCheck]="false">
          </entity-owner>
        </mat-card-content>
      </mat-card>

      <!-- Documents -->
      <mat-card class="w-full">
        <mat-card-content>
          <div class="flex flex-col w-full gap-4">
            <span class="text-lg font-semibold">Documents</span>
            <document
                [entityId]="license.id"
                [entityType]="sharedService.hospitalLicense"
                [editable]="editing"
                [userId]="license.userId"
                [types]="hospitalDocumentTypes">
              </document>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Contacts -->
    <div class="gap-4 py-4">
      <mat-card>
        <mat-card-content>
          <mat-card>
            <mat-card-content class="hospital-contacts-layout">
              <div class="flex flex-col md:flex-row md:gap-4 items-center pb-4 portal-actions">
                <span class="text-lg font-semibold">Contacts</span>
                <button mat-raised-button color="primary" (click)="openContactsPdfDialog()" >View Contacts Export</button>
                <mat-checkbox class="ml-auto" formControlName="bypassDuplicateManagerValidation" value="true">Bypass Duplicate Manager Validation</mat-checkbox>
              </div>
              <!--Review-->
              <div class="flex flex-row w-full gap-2" *ngIf="!editing">
                <div class="flex flex-col gap-4 w-full hospital-contact-flow">
                  <div class="flex flex-col md:flex-row md:gap-4 portal-detail-row" *ngIf="!license.isSicf">
                    <span class="font-semibold">Application for satellite with main hospital out of state?:</span>
                    <span>{{license.mainHospitalOutOfState ? 'Yes' : 'No'}}</span>
                  </div>
                  <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Hospital Administrator</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.hospitalAdminName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.hospitalAdminEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.hospitalAdminPhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Emergency Contact</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.emergencyContactName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.emergencyContactEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.emergencyContactPhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Chief Nursing Officer/Nurse Executive</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.chiefNurseName}}</span>
                        <span *ngIf="licenseForm.get('chiefNurseName')?.hasError('invalidChiefNurseName')" class="text-red-500">Possible Duplicate Name</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.chiefNurseEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.chiefNursePhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Person who filled out this application</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.filerName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.filerEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.filerPhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Nurse Manager Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.nurseManagerName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Title:</span>
                        <span>{{license.nurseManagerTitle}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email: </span>
                        <span>{{license.nurseManagerEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.nurseManagerPhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Direct Care Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.directCareName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Title:</span>
                        <span>{{license.directCareTitle}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.directCareEmail}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.directCarePhone | mask:'000 000-0000'}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Emergency Department Director</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.emergencyDepartmentDirectorName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.emergencyDepartmentDirectorPhone ?? '' | mask:'000 000-0000'}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.emergencyDepartmentDirectorEmail}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Professional/Technical Manager Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.technicalManagerCoChairName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.technicalManagerCoChairPhone ??  '' | mask:'000 000-0000'}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email: </span>
                        <span>{{license.technicalManagerCoChairEmail}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Professional/Technical Staff Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.technicalStaffCoChairName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.technicalStaffCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.technicalStaffCoChairEmail}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Service Staffing Committee Manager Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.serviceStaffingCommitteeManagerCoChairName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.serviceStaffingCommitteeManagerCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email:</span>
                        <span>{{license.serviceStaffingCommitteeManagerCoChairEmail}}</span>
                      </div>
                    </div>
                    <div class="flex flex-col w-1/3">
                      <span class="text-lg font-semibold">Service Staffing Committee Staff Co-Chair</span>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Name:</span>
                        <span>{{license.serviceStaffingCommitteeStaffCoChairName}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Phone:</span>
                        <span>{{license.serviceStaffingCommitteeStaffCoChairPhone ??  '' | mask:'000 000-0000'}}</span>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                        <span class="md:w-1/4 font-semibold">Email: </span>
                        <span>{{license.serviceStaffingCommitteeStaffCoChairEmail}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col md:flex-row md:gap-4 portal-detail-row">
                    <span class="font-semibold">Facility has union representation?:</span>
                    <span>{{license.hasUnionRepresentation ? 'Yes' : 'No'}}</span>
                  </div>
                </div>
              </div>
              <!--Editing-->
              <div class="flex flex-col w-full gap-2 hospital-contact-flow" *ngIf="editing">
                <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                  <div class="md:w-1/3">
                    <span class="font-semibold">Is this application for a hospital satellite for which the main hospital is located outside of Oregon?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="mainHospitalOutOfState" class="flex flex-row items-start gap-1">
                      <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                      <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                      <mat-error *ngIf="licenseForm.get('mainHospitalOutOfState')?.touched && licenseForm.get('mainHospitalOutOfState')?.invalid">
                        You must select an option
                      </mat-error>
                    </mat-radio-group>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Hospital Administrator</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="hospitalAdminName" [errorStateMatcher]="contactNameErrorMatchers['hospitalAdminName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['hospitalAdminName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="hospitalAdminEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="hospitalAdminPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Emergency Contact</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="emergencyContactName" [errorStateMatcher]="contactNameErrorMatchers['emergencyContactName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['emergencyContactName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="emergencyContactEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="emergencyContactPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>

                </div>
                <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Chief Nursing Officer/Nurse Executive</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="chiefNurseName" [errorStateMatcher]="contactNameErrorMatchers['chiefNurseName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['chiefNurseName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('chiefNurseName')?.hasError('required')">
                        Name is required
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('chiefNurseName')?.hasError('invalidChiefNurseName')">
                        Matches an existing Chief Nursing Officer/Nurse Executive or Hospital Administrator
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="chiefNurseEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="chiefNursePhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Person who filled out this application</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="filerName">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="filerEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="filerPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Nurse Manager Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="nurseManagerName" [errorStateMatcher]="contactNameErrorMatchers['nurseManagerName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['nurseManagerName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('nurseManagerName')?.hasError('required')">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                    <div class="hospital-contact-title-phone">
                      <mat-form-field class="flex flex-col w-full md:w-1/2">
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="nurseManagerTitle">
                      </mat-form-field>
                      <mat-form-field class="flex flex-col w-full md:w-1/2">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="nurseManagerPhone" mask="000-000-0000">
                      </mat-form-field>
                    </div>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="nurseManagerEmail">
                    </mat-form-field>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid hospital-contact-group">
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Direct Care Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="directCareName" [errorStateMatcher]="contactNameErrorMatchers['directCareName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['directCareName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('directCareName')?.hasError('required')">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                    <div class="hospital-contact-title-phone">
                      <mat-form-field class="flex flex-col w-full md:w-1/2">
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="directCareTitle">
                      </mat-form-field>
                      <mat-form-field class="flex flex-col w-full md:w-1/2">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="directCarePhone" mask="000-000-0000">
                      </mat-form-field>
                    </div>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="directCareEmail">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Emergency Department Director</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="emergencyDepartmentDirectorName" [errorStateMatcher]="contactNameErrorMatchers['emergencyDepartmentDirectorName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['emergencyDepartmentDirectorName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('emergencyDepartmentDirectorName')?.hasError('required')">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="emergencyDepartmentDirectorEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="emergencyDepartmentDirectorPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Professional/Technical Manager Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="technicalManagerCoChairName" [errorStateMatcher]="contactNameErrorMatchers['technicalManagerCoChairName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['technicalManagerCoChairName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('technicalManagerCoChairName')?.hasError('required')">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="technicalManagerCoChairEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="technicalManagerCoChairPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid hospital-contact-group">
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Professional/Technical Staff Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="technicalStaffCoChairName" [errorStateMatcher]="contactNameErrorMatchers['technicalStaffCoChairName']">
                    <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['technicalStaffCoChairName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="licenseForm.get('technicalStaffCoChairName')?.hasError('required')">
                      Name is required
                    </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="technicalStaffCoChairEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="technicalStaffCoChairPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Service Staffing Committee Manager Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeManagerCoChairName" [errorStateMatcher]="contactNameErrorMatchers['serviceStaffingCommitteeManagerCoChairName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['serviceStaffingCommitteeManagerCoChairName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('serviceStaffingCommitteeManagerCoChairName')?.hasError('required')">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeManagerCoChairEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeManagerCoChairPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col w-1/3">
                    <span class="text-lg font-semibold">Service Staffing Committee Staff Co-Chair</span>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeStaffCoChairName" [errorStateMatcher]="contactNameErrorMatchers['serviceStaffingCommitteeStaffCoChairName']">
                      <mat-error *ngIf="licenseForm.getError('duplicateContactNames')?.['serviceStaffingCommitteeStaffCoChairName'] as conflicts">
                        Name must differ from: {{ conflicts.join(', ') }}.
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('serviceStaffingCommitteeStaffCoChairName')?.hasError('required')">
                        Name is required
                      </mat-error>
                      <mat-error *ngIf="licenseForm.get('serviceStaffingCommitteeStaffCoChairName')?.hasError('invalidStaffingCommitteeStaffCoChair')">
                        Cannot match the name of any manager
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeStaffCoChairEmail">
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="serviceStaffingCommitteeStaffCoChairPhone" mask="000-000-0000">
                    </mat-form-field>
                  </div>
                </div>
                <div class="flex flex-col pt--4 md:w-1/3 portal-full-panel">
                  <span class="text-lg font-semibold">Does this facility have union representation?:</span>
                  <mat-form-field appearance="fill" class="flex-col gap-2">
                    <input matInput formControlName="hasUnionRepresentation" style="display: none;">
                    <mat-radio-group aria-labelledby="has union representation" formControlName="hasUnionRepresentation" class="flex flex-col gap-2 ">
                      <mat-radio-button [value]="true">
                        <span class="font-semibold text-lg underline pr-4">Yes</span>
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        <span class="font-semibold text-lg underline pr-4">No</span>
                      </mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="licenseForm.get('hasUnionRepresentation')?.invalid">
                      You must select an option
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Representative Contact Section  -->
    <mat-card *ngIf="licenseForm.get('hasUnionRepresentation')?.value">
      <mat-card-content>
        <div>

            <div class="flex flex-col gap-4">
              <div class="portal-toolbar">
                <span class="font-semibold text-xl">Representative Contacts</span>
                <button *ngIf="!showRepresentativeContactForm && editing" mat-raised-button color="primary" type="button" (click)="showAddRepresentativeContactForm()">
                  <mat-icon>add</mat-icon>
                  Add Representative Contact
                </button>
              </div>

              <!-- Add/Edit Representative Contact Form -->
              <div *ngIf="showRepresentativeContactForm">

                  <div class="flex flex-col gap-2">
                    <div class="pb-1">
                      <span class="font-semibold text-xl">{{ editingRepresentativeContact ? 'Edit' : 'Add' }} Representative Contact</span>
                    </div>
                    <form [formGroup]="representativeContactForm">
                      <div class="flex flex-col gap-2">
                        <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                          <div class="flex flex-col gap-2 md:w-1/2">
                            <mat-form-field>
                              <mat-label>Select the Exclusive Representative that represents hospital staff</mat-label>
                              <mat-select formControlName="representativeType">
                                <mat-option *ngFor="let option of representativeTypeOptions" [value]="option">
                                  {{ option }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="representativeContactForm.get('representativeType')?.hasError('required')">
                                Representative Type is required
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="flex flex-col gap-2 md:w-1/2" *ngIf="representativeContactForm.get('representativeType')?.value === 'Other'">
                            <mat-form-field>
                              <mat-label>If other, list the Exclusive Representative:</mat-label>
                              <input matInput formControlName="representativeTypeOther" placeholder="Enter representative type">
                              <mat-error *ngIf="representativeContactForm.get('representativeTypeOther')?.hasError('required')">
                                Please specify the representative type
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="flex flex-col gap-2 md:w-1/2">
                            <mat-form-field>
                              <mat-label>Which hospital staff are represented by this Exclusive Representative?</mat-label>
                              <input matInput formControlName="representativeStaff" placeholder="Hospital's primary contact person for this Exclusive Representative">
                              <mat-error *ngIf="representativeContactForm.get('representativeStaff')?.hasError('required')">
                                Representative Staff is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                          <div class="flex flex-col gap-2 md:w-1/3">
                            <mat-form-field>
                              <mat-label>Name of Exclusive Representative Contact Person</mat-label>
                              <input matInput formControlName="contactName">
                              <mat-error *ngIf="representativeContactForm.get('contactName')?.hasError('required')">
                                Contact Name is required
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="flex flex-col gap-2 md:w-1/3">
                            <mat-form-field>
                              <mat-label>Phone of Exclusive Representative Contact Person</mat-label>
                              <input matInput formControlName="contactPhone" mask="000-000-0000">
                              <mat-error *ngIf="representativeContactForm.get('contactPhone')?.hasError('required')">
                                Contact Phone is required
                              </mat-error>
                              <mat-error *ngIf="representativeContactForm.get('contactPhone')?.hasError('pattern')">
                                Format number as 000-000-0000
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="flex flex-col gap-2 md:w-1/3">
                            <mat-form-field>
                              <mat-label>Email of Exclusive Representative Contact Person</mat-label>
                              <input matInput formControlName="contactEmail">
                              <mat-error *ngIf="representativeContactForm.get('contactEmail')?.hasError('required')">
                                Contact Email is required
                              </mat-error>
                              <mat-error *ngIf="representativeContactForm.get('contactEmail')?.hasError('email')">
                                Not a valid email
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="flex flex-row gap-2 justify-end portal-actions">
                          <button mat-button type="button" (click)="cancelEditRepresentativeContact()">
                            Cancel
                          </button>
                          <button mat-raised-button color="primary" type="button"
                                  [disabled]="representativeContactForm.invalid"
                                  (click)="saveRepresentativeContact()">
                            {{ editingRepresentativeContact ? 'Update' : 'Add' }} Contact
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

              </div>

              <!-- Representative Contacts Table -->
              <div *ngIf="!showRepresentativeContactForm && license.representativeContacts.length > 0">

                  <div class="flex flex-col gap-2">
                    <div class="mat-elevation-z2">

                      <mat-table mat-table [dataSource]="representativeContactDataSource" matSort #representativeContactSort="matSort" class="w-full">
                        <ng-container matColumnDef="representativeType">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Representative Type</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            {{ contact.representativeType }}
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="representativeStaff">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Representative Staff</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            {{ contact.representativeStaff }}
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="contactName">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Name</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            {{ contact.contactName }}
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="contactPhone">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Phone</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            {{ contact.contactPhone }}
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="contactEmail">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Email</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            {{ contact.contactEmail }}
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef mat-sort-header="">Actions</mat-header-cell>
                          <mat-cell tabindex="0" *matCellDef="let contact">
                            <button mat-icon-button color="primary"
                                    (click)="editRepresentativeContact(contact)"
                                    [disabled]="!editing"
                                    matTooltip="Edit">
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn"
                                    (click)="deleteRepresentativeContact(contact)"
                                    [disabled]="!editing"
                                    matTooltip="Delete">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="representativeContactColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: representativeContactColumns"></mat-row>
                      </mat-table>
                      <mat-paginator [pageSizeOptions]="[5, 10, 20]" #representativeContactPaginator="matPaginator">
                      </mat-paginator>
                    </div>
                  </div>

              </div>

              <div *ngIf="!showRepresentativeContactForm && license.representativeContacts.length === 0">
                <span class="text-gray-500">No representative contacts have been added.</span>
              </div>
            </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!--Services-->
    <div class="flex flex-col xl:flex-row gap-4 py-4 portal-section-grid">
      <mat-card class="w-full xl:w-1/2">
        <mat-card-content>
          <div class="flex flex-col w-full gap-4">
            <!--Review-->
            <span class="text-lg font-semibold">Services</span>
            <span *ngIf="license.inpatientBeds + license.inpatientPsychiatricBeds + license.satelliteInpatientPsychiatricBeds > 25 &&
                         license.classification == 'Low Occupancy Acute Care Hospital'" class="portal-error">Low Occupancy classification hospital exceeds 25 beds</span>
            <div class="flex flex-col gap-2 w-full" *ngIf="!editing">
              <div class="flex flex-row gap-2 portal-detail-row">
                <span class="font-semibold">Total on-campus inpatient beds:</span>
                <span>{{license.inpatientBeds}}</span>
              </div>
              <div class="flex flex-row gap-2 portal-detail-row" *ngIf="!licenseForm.get('isSicf')?.value">
                <span class="font-semibold">Total on-campus inpatient psychiatric beds:</span>
                <span>{{license.inpatientPsychiatricBeds}}</span>
              </div>
              <div class="flex flex-row gap-2 portal-detail-row" *ngIf="!licenseForm.get('isSicf')?.value">
                <span class="font-semibold">Total satellite inpatient psychiatric beds:</span>
                <span>{{license.satelliteInpatientPsychiatricBeds}}</span>
              </div>
              <div class="flex flex-row gap-2 portal-detail-row" *ngIf="license.classification == 'General Hospital' || license.classification == 'Psychiatric Hospital'">
                <span class="font-semibold">Swing Beds:</span>
                <span *ngIf="license.swingBeds">Yes</span>
                <span *ngIf="!license.swingBeds">No</span>
              </div>
              <div class="flex flex-row gap-2" *ngIf="!licenseForm.get('isSicf')?.value">
                <span class="font-semibold">Services Provided:</span>
                <div class="flex flex-col">
                  <span *ngIf="license.maternity">Maternity</span>
                  <span *ngIf="license.surgical">Surgical</span>
                  <span *ngIf="license.emergency">Emergency</span>
                </div>
              </div>
            </div>
            <!--Editing-->
            <div class="flex flex-col gap-2 w-1/2 portal-full-panel" *ngIf="editing">
              <div class="flex flex-col md:flex-row md:gap-2 portal-field-grid">
                <mat-form-field class="w-full md:w-1/3">
                  <mat-label>Inpatient beds</mat-label>
                  <input type="number" matInput formControlName="inpatientBeds" min="0">
                  <mat-error *ngIf="licenseForm.get('inpatientBeds')?.invalid">
                    You must enter a number
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full md:w-1/3" *ngIf="!licenseForm.get('isSicf')?.value">
                  <mat-label>Inpatient Psychiatric Beds</mat-label>
                  <input type="number" matInput formControlName="inpatientPsychiatricBeds" min="0">
                  <mat-error *ngIf="licenseForm.get('inpatientPsychiatricBeds')?.invalid">
                    You must enter a number
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full md:w-1/3" *ngIf="!licenseForm.get('isSicf')?.value">
                  <mat-label>Satellite Inpatient Psychiatric Beds</mat-label>
                  <input type="number" matInput formControlName="satelliteInpatientPsychiatricBeds" min="0">
                  <mat-error *ngIf="licenseForm.get('satelliteInpatientPsychiatricBeds')?.invalid">
                    You must enter a number
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col md:flex-row portal-section-grid" *ngIf="licenseForm.get('classification')?.value == 'General Hospital' ||
                                                            licenseForm.get('classification')?.value == 'Psychiatric Hospital'">
                <div class="flex flex-row gap-2 md:w-1/3">
                  <div class="flex flex-col gap-2">
                    <span class="font-semibold">Swing Beds?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="swingBeds" class="flex flex-row items-start gap-1">
                      <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                      <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="licenseForm.get('swingBeds')?.touched && licenseForm.get('swingBeds')?.invalid">
                      You must select an option
                    </mat-error>
                  </div>
                </div>

              </div>
              <div class="flex flex-col" *ngIf="!licenseForm.get('isSicf')?.value && licenseForm.get('isSicf')?.value !== null">
                <span class="font-semibold">Services Provided</span>
                <div class="flex flex-row gap-2">
                  <mat-checkbox formControlName="maternity" value="maternity">Maternity</mat-checkbox>
                  <mat-checkbox formControlName="surgical" value="surgical">Surgical</mat-checkbox>
                  <mat-checkbox formControlName="emergency" value="emergency">Emergency</mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="gap-4 py-4" *ngIf="!licenseForm.get('isSicf')?.value">
      <mat-card>
        <mat-card-content>
          <div class="flex flex-col w-full gap-4">
            <span class="text-lg font-semibold">On-Campus Buildings</span>
            <on-campus-building
              [entityId]="license.id"
              [entityType]="sharedService.hospitalLicense"
              [canEdit]="editing"
              [HospitalLicenseId]="license.licenseId">
            </on-campus-building>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="gap-4 py-4" *ngIf="!licenseForm.get('isSicf')?.value">
      <mat-card>
        <mat-card-content>
          <div class="flex flex-col w-full gap-4">
            <span class="text-lg font-semibold">Off-Campus Satellite Locations</span>
            <satellite-location
              [canEdit]="editing"
              [entityId]="license.id"
              [entityType]="sharedService.hospitalLicense"
              [HospitalLicenseId]="license.licenseId">
            </satellite-location>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!--Payments-->
    <div class="flex flex-col xl:flex-row gap-4 py-4 portal-section-grid">
      <mat-card class="w-full 2xl:w-1/2">
        <mat-card-content>
          <div class="flex flex-col w-full gap-4">
            <app-manage-payments
              [entityId]="license.id.toString()"
              [entityType]="sharedService.hospitalLicense"
              [allowMultiplePayments]="true"
              [allowDelete]="false"
              [editingPayment]="true"
              (notifyParent)="paymentsLoadedEvent(true)">
            </app-manage-payments>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Notes & Staff Management -->
    <div class="flex flex-col md:flex-row md:gap-2 mt-4 portal-section-grid">
      <!-- Notes-->
      <mat-card class="w-full md:w-1/2">
        <mat-card-content>
        <!-- Notes -->
          <div class="flex flex-col w-full gap-4">
            <notes [entityId]="license.id"
                  [entityType]="sharedService.hospitalLicense">
            </notes>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Staff Management -->
      <mat-card class="w-full md:w-1/2">
        <mat-card-content>
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col md:flex-row gap-6 w-full">
                <div class="flex flex-col gap-4 w-full">
                  <span class="font-semibold">License Status</span>

                  <div class="flex flex-row gap-2 portal-detail-row">
                    <span class="font-semibold md:w-1/3">Application Date:</span>
                    <span>{{license.applicationDate | date: 'MM/dd/yyyy'}}</span>
                  </div>

                  <div class="flex flex-col gap-4" *ngIf="!editing">
                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Approved Date:</span>
                      <span>{{license.approvedDate | date: 'MM/dd/yyyy'}}</span>
                    </div>

                    <div class="flex flex-row gap-2 portal-detail-row">
                      <span class="font-semibold md:w-1/3">Expiration Date:</span>
                      <span>{{license.expirationDate | date: 'MM/dd/yyyy'}}</span>
                    </div>
                  </div>

                  <div class="flex flex-col md:w-1/2 portal-full-panel" *ngIf="editing">
                    <mat-form-field>
                      <mat-label>Approved Date</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="approvedDate" matInput [matDatepicker]="approved" />
                      <mat-datepicker-toggle matSuffix [for]="approved"></mat-datepicker-toggle>
                      <mat-datepicker #approved>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>Expiration Date</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="expirationDate" matInput [matDatepicker]="expiration" />
                      <mat-datepicker-toggle matSuffix [for]="expiration"></mat-datepicker-toggle>
                      <mat-datepicker #expiration>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <span class="font-semibold">Current:</span>
                    <div class="flex flex-col">
                      <span *ngFor="let status of license.statuses">{{status.label}}</span>
                    </div>
                  </div>

                  <div class="flex flex-col gap-2" *ngIf="paymentsLoaded">
                    <span class="font-semibold">Select a Status</span>
                    <mat-form-field appearance="fill" class="md:w-1/2 portal-full-panel">
                      <mat-label>Status</mat-label>
                      <mat-select formControlName="status">
                        <mat-option *ngFor="let status of sharedService.statusList" [value]="status.id">{{status.label}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-row gap-4 portal-actions">
                    <button type="button" mat-raised-button [color]="editing? 'warn' : 'primary'" (click)="toggleEditing(!editing)"
                            [matTooltip]="editing? 'Stop Editing' : 'Edit'" [attr.aria-label]="editing? 'Stop Editing' : 'Edit'"
                            matTooltipShowDelay="500" matTooltipHideDelay="200">
                      <mat-icon>{{ editing? 'edit_off' : 'edit' }}</mat-icon>
                    </button>
                    <button type="button" mat-raised-button color="primary" (click)="saveLicense()">Save License</button>
                    <button type="button" mat-raised-button color="primary" (click)="closeLicense()">Close</button>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>

    </div>
  </form>
</div>
